import React from 'react';
import PropTypes from 'prop-types';

import { Abstrap, Icon } from '..';

const propTypes = {
    ...Abstrap.propTypes,
    disabled: PropTypes.bool,
    type: PropTypes.oneOf(['edit', 'delete', 'export', 'refresh']),
};

const defaultProps = {
    ...Abstrap.defaultProps,
    componentClass: 'div',
    disabled: false,
    type: 'delete',
};

class IconAction extends Abstrap {

    getClassNameSchema() {
        const {
            className,
            disabled,
            type,
        } = this.props;
        return [
            's-iconaction',
            ['edit', 'export', 'refresh'].indexOf(type) > -1 ? 's-iconaction_edit' : false,
            type === 'delete' ? 's-iconaction_delete' : false,
            disabled ? 's-iconaction_disabled' : false,
            className,
        ];
    }

    renderChildren() {
        const { type } = this.props;
        let icon = null;
        switch (type) {
            case 'edit':
                icon = 'pencil';
                break;
            case 'export':
                icon = 'download';
                break;
            case 'refresh':
                icon = 'refresh';
                break;
            default:
                icon = 'times';
        }
        return (
            <Icon icon={icon} className="s-iconaction__icon" />
        );
    }

}

IconAction.propTypes = propTypes;

IconAction.defaultProps = defaultProps;

export default IconAction;
